import { useState, useMemo } from 'react';
import { Button, ModalHeader, ModalBody, Modal, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';

const ModalSesion = (props) => {
  const [modalState, setModalState] = useState(true);
  const handleModalState = () => {
    if (modalState === true) {
      setModalState(false);
    } else {
      setModalState(true);
    }
  };

  const isOpen = useMemo(() => {
    if (props.isOpen !== undefined && props.isOpen !== null) {
      return props.isOpen;
    }
    return modalState;
  }, [props.isOpen, modalState]);

  return (
    <Modal isOpen={isOpen} centered>
      <ModalHeader>{props.header}</ModalHeader>
      <ModalBody>{props.body}</ModalBody>
      <ModalFooter>
        <Button
          color="danger"
          onClick={() => {
            if (props.setIsOpen) {
              props.setIsOpen(false);
            } else {
              handleModalState();
            }
          }}
        >
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};
ModalSesion.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  body: PropTypes.string,
  header: PropTypes.string,
};
export default ModalSesion;
